module.exports = __webpack_public_path__ + "static/media/helpcard_recommend.4ba9fb8e.svg";